<template>
  <div class="flex-grow-1 d-flex flex-column overflow-hidden">
    <!-- 搜索条件卡片 -->
    <v-card class="rounded-xl card-bg card-bd flex-shrink-0 px-6 py-5" variant="elevated" elevation="0">
      <div class="d-flex align-center flex-wrap ga-6">
        <div class="search-item">
          <span class="search-label">用户名称</span>
          <v-text-field v-model="userName" placeholder="请输入用户名" variant="outlined" density="compact" hide-details
            rounded="xl" class="search-input" @keyup.enter="updateUserList" @input="debounceUpdateUserList" />
        </div>
        <div class="search-item">
          <span class="search-label">手机号</span>
          <v-text-field v-model="userPhone" placeholder="请输入手机号" variant="outlined" density="compact" hide-details
            rounded="xl" class="search-input" @keyup.enter="updateUserList" @input="debounceUpdateUserList" />
        </div>

        <div class="search-actions d-flex ga-3 ml-auto">
          <v-btn color="#2655f1" rounded="xl" @click="updateUserList" class="action-btn">
            <v-icon start icon="mdi-magnify" />查询
          </v-btn>
          <v-btn variant="outlined" color="#2655f1" rounded="xl" @click="resetQuery" class="action-btn">
            <v-icon start icon="mdi-refresh" />重置
          </v-btn>
          <v-btn variant="outlined" color="#2655f1" rounded="xl" @click="newUser" class="action-btn">
            <v-icon start icon="mdi-plus" />新增用户
          </v-btn>
        </div>
      </div>
    </v-card>

    <div class="flex-grow-1 d-flex overflow-hidden mt-3" style="gap: 16px;">
      <v-card class="rounded-xl card-bg card-bd flex-shrink-0" variant="elevated" elevation="0"
        style="width: 250px; display: flex; flex-direction: column;" :loading="roleListLoading">
        <div class="p-4">
          <!-- 搜索框 -->
          <div class="search-wrapper mb-4">
            <v-text-field v-model="filterText" placeholder="输入关键字筛选" variant="outlined" density="compact" hide-details
              rounded="xl" class="search-input" style="width: 100%;" />
          </div>

          <!-- 组织树 -->
          <div class="device-tree flex-grow-1 overflow-y-auto" style="max-height: 500px;">
            <div v-if="groupTree.length === 0" class="tree-empty text-center text-medium-emphasis py-8">
              暂无数据
            </div>
            <el-tree ref="treeRef" v-else :data="groupTree" @current-change="onTreeChange"
              :filter-node-method="filterNode" node-key="deptId" :props="{ children: 'children', label: 'deptName' }"
              :default-expand-all="true">
            </el-tree>
          </div>
        </div>
      </v-card>
      <v-card class="rounded-xl card-bg card-bd card-table flex-grow-1 d-flex flex-column" variant="elevated"
        elevation="0" :loading="loading">
        <div class="table-wrapper flex-grow-1 overflow-hidden d-flex flex-column">
          <v-table fixed-header height="100%" style="width: 100%; background: transparent" class="gm-table border-none">
            <thead>
              <tr>
                <th style="width: 120px">用户ID</th>
                <th style="width: 200px">用户名称</th>
                <th style="width: 200px">昵称</th>
                <th style="width: 120px">用户状态</th>
                <th style="width: 120px">工号</th>
                <th style="width: 180px">手机号</th>
                <th style="width: 220px">创建时间</th>
                <th style="width: 200px" class="text-center">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in userList" :key="user.userId">
                <td class="text-medium-emphasis">{{ user.userId }}</td>
                <td style="color: #2655f1; font-weight: 500">{{ user.userName }}</td>
                <td>{{ user.nickName || "--" }}</td>
                <td>
                  <v-chip :color="user.status === '0' ? '#33BE36' : user.status === '1' ? '#FF6A46' : '#FFB800'"
                    variant="tonal" class="status-chip">
                    {{ user.status === '0' ? '正常' : user.status === '1' ? '停用' : '未激活' }}
                  </v-chip>
                </td>
                <td>{{ user.jobNum || "--" }}</td>
                <td>{{ user.phonenumber || "--" }}</td>
                <td class="text-medium-emphasis">{{ user.createTime || "--" }}</td>
                <td>
                  <div class="d-flex ga-2">
                    <v-btn variant="text" color="#2655f1" rounded="xl" @click="editUser(user)">修改</v-btn>
                    <v-btn variant="text" color="#2655f1" rounded="xl" @click="resetPassword(user)">重置密码</v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
        <div v-if="!loading && userList.length === 0" class="text-center py-12 text-medium-emphasis">
          {{ userName || userPhone ? '未找到匹配的用户记录' : '暂无用户数据' }}
        </div>
        <div v-if="loading" class="text-center py-12 text-medium-emphasis">
          加载中…
        </div>
        <div class="px-6 py-4 d-flex justify-end">
          <TablePagination :total="total" :pageSize="pageSize" v-model="pageNum" @change="onCurrentChange" />
        </div>
      </v-card>
    </div>

    <!-- 用户编辑对话框 -->
    <v-dialog v-model="visible" max-width="800px" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-6">
          <div class="text-h5">
            <span style="color: #2655f1">{{ op === 'add' ? '新增' : '修改' }}</span>
            <span>用户</span>
          </div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="visible = false" />
        </div>
        <v-card-text class="pa-8 pt-0 pb-4 scrollbar-hide" style="max-height: 88vh; overflow-y: auto">
          <form class="form form--dialog" ref="formRef" novalidate>
            <Step :hasTab="hasTab" :op="op" />
            <div class="tabChangebg">
              <div class="tab-change" v-if="hasTab === 1">
                <!-- 个人信息 -->
                <div class="form-item-group form-item-user">
                  <div class="form-section">
                    <div class="form-grid-2">
                      <div class="form-group grid-full">
                        <label>用户名 <span class="required-star">*</span></label>
                        <v-text-field v-model="formValues.userName" placeholder="输入用户名，登录使用" required
                          :disabled="op == 'edit'" variant="outlined" density="compact" class="gm-input" hide-details />
                      </div>
                      <div class="form-group grid-full">
                        <label>昵称 <span class="required-star">*</span></label>
                        <v-text-field v-model="formValues.nickName" placeholder="输入你的昵称" required variant="outlined"
                          density="compact" class="gm-input" hide-details />
                      </div>
                      <div class="form-group grid-full">
                        <label>工号</label>
                        <v-text-field v-model="formValues.jobNum" placeholder="请输入工号" variant="outlined"
                          density="compact" class="gm-input" hide-details />
                      </div>
                      <div class="form-group grid-full">
                        <label>用户状态 <span class="required-star">*</span></label>
                        <v-radio-group v-model="formValues.status" inline hide-details class="gm-radio-group">
                          <div class="d-flex ga-6 w-100">
                            <v-radio label="正常" value="0" class="gm-radio-card flex-1" color="#2655F1" />
                            <v-radio label="停用" value="1" class="gm-radio-card flex-1" color="#2655F1" />
                            <v-radio label="未激活" value="2" class="gm-radio-card flex-1" color="#2655F1" />
                          </div>
                        </v-radio-group>
                      </div>
                      <div class="form-group grid-full">
                        <div class="form-section-title mb-2">续费通知</div>
                        <label>开启状态</label>
                        <v-radio-group v-model="formValues.disableEnabled" inline hide-details class="gm-radio-group">
                          <div class="d-flex ga-6 w-100">
                            <v-radio label="关闭" :value="0" class="gm-radio-card flex-1" color="#2655F1" />
                            <v-radio label="开启" :value="1" class="gm-radio-card flex-1" color="#2655F1" />
                          </div>
                        </v-radio-group>
                      </div>
                      <div class="form-group grid-full" v-if="formValues.disableEnabled == 1">
                        <label>到期时间 <span class="required-star">*</span></label>
                        <v-menu v-model="dateMenuVisible" :close-on-content-click="false" location="bottom" offset="8">
                          <template #activator="{ props }">
                            <v-text-field v-bind="props" :value="formatDate(formValues.disableClosingDate)"
                              placeholder="请选择到期日期" variant="outlined" density="compact" class="gm-input" hide-details
                              readonly />
                          </template>
                          <v-date-picker v-model="formValues.disableClosingDate" required variant="outlined"
                            density="compact" class="gm-input" hide-details format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" @update:model-value="dateMenuVisible = false" />
                        </v-menu>
                      </div>
                      <div class="form-group grid-full" v-if="formValues.disableEnabled == 1">
                        <label>通知消息 <span class="required-star">*</span></label>
                        <v-textarea v-model="formValues.promptMessage" placeholder="请输入通知消息" required :rows="2"
                          variant="outlined" density="compact" class="gm-input" hide-details />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-change" v-if="hasTab === 2">
                <!-- 组织与角色 -->
                <div class="form-item-group form-item-user">
                  <div class="form-section">
                    <div class="form-grid-2">
                      <div class="form-group grid-full">
                        <label>组织 <span class="required-star">*</span></label>
                        <input type="text" v-model="formValues.deptId" required
                          style="opacity: 0;clip-path: rect(0 0 0 0);display: none;">
                        <v-menu v-model="deptMenuVisible" :close-on-content-click="false" location="bottom" offset="8"
                          max-width="520">
                          <template #activator="{ props }">
                            <v-text-field v-bind="props" :model-value="selectedDeptLabel" placeholder="请选择组织"
                              variant="outlined" density="compact" class="gm-input" readonly hide-details
                              append-inner-icon="mdi-chevron-down" />
                          </template>
                          <v-card class="dept-select-panel" rounded="lg">
                            <v-card-text>
                              <v-text-field v-model="deptFilterText" placeholder="输入关键字筛选组织" variant="outlined"
                                density="compact" class="gm-input dept-search-input" hide-details clearable />
                              <div class="dept-select-tree-wrap mt-3">
                                <el-tree ref="deptSelectTreeRef" :data="groupTree"
                                  :props="{ children: 'children', label: 'label' }" node-key="deptId"
                                  :filter-node-method="filterNode" highlight-current @node-click="onDeptSelect" />
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </div>
                      <div class="form-group grid-full">
                        <label>角色 <span class="required-star">*</span></label>
                        <div class="rule__wrap">
                          <div class="user-tab-line" v-for="sysRole in roleList" :key="sysRole.systemSign"
                            style="display: flex; align-items: center; margin-bottom: 12px;">
                            <label class="user-tab-label">
                              <span>{{ sysRole.systemName }}</span>
                            </label>
                            <v-select v-model="sysRole.__selected_value" :items="sysRole.roles" item-title="roleName"
                              item-value="roleId" style="flex: 1; margin-left: -48px;" variant="outlined"
                              density="compact" class="gm-input" hide-details />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-change" v-if="hasTab === 3">
                <!-- 密码设置 -->
                <div class="form-item-group form-item-user">
                  <div class="form-section">
                    <div class="form-grid-2">
                      <div class="form-group grid-full">
                        <label>密码 <span class="required-star">*</span></label>
                        <v-text-field :type="op == 'add' && showPassword ? 'text' : 'password'"
                          v-model="formValues.password" placeholder="请输入密码" required :disabled="op == 'edit'"
                          variant="outlined" density="compact" class="gm-input" hide-details
                          :append-inner-icon="op == 'add' ? (showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline') : undefined"
                          @click:append-inner="op == 'add' && (showPassword = !showPassword)" />
                      </div>
                      <div class="form-group grid-full" v-show="op == 'add'">
                        <label>确认密码 <span class="required-star">*</span></label>
                        <v-text-field :type="showRepassword ? 'text' : 'password'" v-model="formValues.repassword"
                          placeholder="请再次输入密码" required :disabled="op == 'edit'" variant="outlined" density="compact"
                          class="gm-input" hide-details
                          :append-inner-icon="showRepassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                          @click:append-inner="showRepassword = !showRepassword" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-change" v-if="hasTab === 4">
                <!-- 联系方式 -->
                <div class="form-item-group form-item-user">
                  <div class="form-section">
                    <div class="form-grid-2">
                      <div class="form-group">
                        <label>手机号</label>
                        <v-text-field v-model="formValues.phonenumber" placeholder="请输入手机号" variant="outlined"
                          density="compact" class="gm-input" hide-details @input="onPhoneInput" />
                      </div>
                      <div class="form-group">
                        <label>邮箱</label>
                        <v-text-field v-model="formValues.email" placeholder="请输入邮箱" variant="outlined"
                          density="compact" class="gm-input" hide-details />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </v-card-text>
        <v-card-actions class="px-8 pb-8 pt-0 justify-end">
          <v-spacer></v-spacer>
          <v-btn v-if="hasTab > 1" @click="onClickup" variant="flat" color="#D9D9D9"
            class="gm-btn-secondary px-10 mr-4">上一步</v-btn>
          <v-btn v-if="!(hasTab === 4)" color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white"
            @click="onClickDown(formRef)">下一步</v-btn>
          <v-btn v-if="hasTab === 4" color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white"
            @click="onSubmit">确认</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 重置密码对话框 -->
    <v-dialog v-model="passwordVisible" max-width="500px" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-6">
          <div class="text-h5">
            <span style="color: #2655f1">重置</span>
            <span>密码</span>
          </div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="passwordVisible = false" />
        </div>
        <v-card-text class="pa-8 pt-0 pb-4 scrollbar-hide" style="max-height: 88vh; overflow-y: auto">
          <form class="form form--dialog" ref="pwdRef" novalidate>
            <div class="form-grid-2">
              <div class="form-group grid-full">
                <label>用户名</label>
                <div class="user-name-display">{{ passwordForm.userName }}</div>
              </div>
              <div class="form-group grid-full">
                <label>新密码 <span class="required-star">*</span></label>
                <v-text-field :type="showResetPassword ? 'text' : 'password'" v-model="passwordForm.password"
                  placeholder="请输入密码" variant="outlined" density="compact" class="gm-input" hide-details
                  :append-inner-icon="showResetPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append-inner="showResetPassword = !showResetPassword" />
              </div>
              <div class="form-group grid-full">
                <label>重复新密码 <span class="required-star">*</span></label>
                <v-text-field :type="showResetRepassword ? 'text' : 'password'" v-model="passwordForm.repassword"
                  placeholder="请重复新密码" variant="outlined" density="compact" class="gm-input" hide-details
                  :append-inner-icon="showResetRepassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append-inner="showResetRepassword = !showResetRepassword" />
              </div>
            </div>
          </form>
        </v-card-text>
        <v-card-actions class="px-8 pb-8 pt-0 justify-end">
          <v-spacer></v-spacer>
          <v-btn @click="passwordVisible = false" variant="flat" color="#D9D9D9"
            class="gm-btn-secondary px-10 mr-4">取消</v-btn>
          <v-btn color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white"
            @click="onPasswordConfirm(pwdRef)">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from "vue"
import { eui } from 'ems-ui'
import TablePagination from '@/components/TablePagination/index.vue'
import Step from "./step.vue"
import { debounce } from "@/utils/index.js"
import { listUser, listDept, resetUserPwd, addUser, getItem, updateUser, listChannelRole, list2tree } from "../user/user.js"

// user list
function useUserList() {
  const loading = ref(false)
  const pageSize = ref(10);
  const pageNum = ref(1);
  const total = ref(0);
  const userList = ref([])
  const userName = ref('')
  const userPhone = ref('')
  const userDept = ref('')

  async function updateUserList() {
    loading.value = true
    let res = await listUser({
      pageNum: pageNum.value,
      pageSize: pageSize.value,
      systemSign: '',
      userName: userName.value,
      deptId: userDept.value,
      phonenumber: userPhone.value,
    })

    userList.value = res?.rows || []
    total.value = res?.total || 0
    loading.value = false
  }

  updateUserList()

  function onCurrentChange(page) {
    // if (page) {
    //   pageNum.value = page
    // }
    updateUserList()
  }

  return {
    pageSize,
    pageNum,
    total,
    userList,
    updateUserList,
    onCurrentChange,
    userName,
    userDept,
    userPhone,
    loading,
  }
}

const {
  loading,
  pageSize,
  pageNum,
  total,
  userList,
  userName,
  userPhone,
  userDept,
  updateUserList,
  onCurrentChange,
} = useUserList()

const debounceUpdateUserList = debounce(updateUserList, 500, false)

// 重置查询条件
function resetQuery() {
  userName.value = ''
  userPhone.value = ''
  userDept.value = ''
  pageNum.value = 1
  // 选中树的第一个节点
  if (groupTree.value.length > 0 && treeRef.value) {
    treeRef.value.setCurrentKey(groupTree.value[0].deptId)
  }
  updateUserList()
}
const visible = ref(false)

const op = ref('add')

const showPassword = ref(false)
const showRepassword = ref(false)
const showResetPassword = ref(false)
const showResetRepassword = ref(false)


function newUser() {
  op.value = 'add'
  visible.value = true;
  hasTab.value = 1

  showPassword.value = false
  showRepassword.value = false

  formValues.userName = ''
  formValues.nickName = ''
  formValues.jobNum = ''
  formValues.status = '0'

  formValues.deptId = ''
  // 固定设置101商业版
  systemSigns.value = ['gemini3']

  resetSelectdValue()

  formValues.password = ''
  formValues.repassword = ''


  formValues.phonenumber = ''
  formValues.email = ''

  // id
  formValues.userId = undefined

}

async function editUser(record) {
  op.value = 'edit'
  visible.value = true
  hasTab.value = 1

  showPassword.value = false
  showRepassword.value = false

  // step 1
  formValues.userName = record.userName
  formValues.nickName = record.nickName
  formValues.jobNum = record.jobNum
  formValues.status = record.status

  // step 2
  formValues.deptId = record.deptId
  let detail = await getItem(record.userId)

  formValues.disableEnabled = detail.data.disableEnabled
  formValues.disableClosingDate = detail.data.disableClosingDate || ''
  formValues.promptMessage = detail.data.promptMessage || ''

  // 选中系统，确保包含gemini3
  systemSigns.value = detail.systems || []
  if (!systemSigns.value.includes('gemini3')) {
    systemSigns.value.push('gemini3')
  }
  // 保存原始的 roleIds 对象
  originalRoleIds.value = typeof detail.roleIds === 'object' && detail.roleIds != null ? { ...detail.roleIds } : {}
  // 选中对应的下拉框
  if (typeof detail.roleIds === 'object' && detail.roleIds != null) {
    Object.keys(detail.roleIds).forEach(roleId => {
      let systemSign = detail.roleIds[roleId]
      for (const sys of roleList.value) {
        if (sys.systemSign === systemSign) {
          sys.__selected_value = Number(roleId)
        }
      }
    })
  }

  // step 3 password
  formValues.password = detail.data.password
  formValues.repassword = detail.data.password

  // step 4
  formValues.phonenumber = record.phonenumber
  formValues.email = record.email

  // id
  formValues.userId = record.userId
}

const systemSigns = ref([])
const originalRoleIds = ref({})  // 保存原始的 roleIds 对象
const roleIds = computed(() => {
  const ids = []
  for (const sys of roleList.value) {
    if (sys.__selected_value !== undefined && sys.__selected_value !== null && sys.__selected_value !== '') {
      ids.push(Number(sys.__selected_value))
    }
  }
  return ids
})

const formValues = reactive({
  deptId: 0,
  userName: "",
  nickName: "",
  password: "",
  repassword: "",
  phonenumber: "",
  email: "",
  status: "0",
  remark: "",
  jobNum: "",
  roleIds: roleIds,
  systemSigns: systemSigns,
  disableEnabled: 0,
  disableClosingDate: "",
  promptMessage: "",
});


//#endregion

const formRef = ref(null)
const dateMenuVisible = ref(false)

const hasTab = ref(1);
let isSelectRule = computed(() => {
  return true
})

let password_is_valid = computed(() => {
  if (hasTab.value == 3) {
    return formValues.password === formValues.repassword
  }
  return true
})

const onClickup = () => {
  hasTab.value = hasTab.value > 1 ? hasTab.value - 1 : 1;
};

const onClickDown = (formElement) => {
  // 阻止默认的表单验证提示
  formElement.noValidate = true;

  // 手动验证必填字段
  if (hasTab.value === 1) {
    if (!String(formValues.userName || '').trim()) {
      eui.showToast('请输入用户名', 'error');
      return;
    }
    if (!String(formValues.nickName || '').trim()) {
      eui.showToast('请输入昵称', 'error');
      return;
    }
    if (!String(formValues.status || '').trim()) {
      eui.showToast('请选择用户状态', 'error');
      return;
    }
  } else if (hasTab.value === 2) {
    if (!String(formValues.deptId || '').trim()) {
      eui.showToast('请选择组织', 'error');
      return;
    }
  } else if (hasTab.value === 3) {
    if (op.value === 'add') {
      if (!String(formValues.password || '').trim()) {
        eui.showToast('请输入密码', 'error');
        return;
      }
      if (formValues.password.length < 5) {
        eui.showToast('请输入至少5位密码', 'error');
        return;
      }
      if (!String(formValues.repassword || '').trim()) {
        eui.showToast('请输入确认密码', 'error');
        return;
      }
      if (formValues.repassword.length < 5) {
        eui.showToast('请输入至少5位确认密码', 'error');
        return;
      }
      if (!password_is_valid.value) {
        eui.showToast('两次输入的密码不一致', 'error');
        return;
      }
    }
  }

  hasTab.value = hasTab.value > 4 ? 4 : hasTab.value + 1;
};

const onSubmit = async () => {
  // 验证手机号格式
  if (String(formValues.phonenumber || '').trim()) {
    const phone = String(formValues.phonenumber || '').trim();
    if (phone.length !== 11) {
      eui.showToast('请输入11位手机号', 'error');
      return;
    }
  }

  // 确保systemSigns包含gemini3
  const finalSystemSigns = [...systemSigns.value]
  if (!finalSystemSigns.includes('gemini3')) {
    finalSystemSigns.push('gemini3')
  }

  // 构建临时 roleIds 对象：保留原始数据，只更新 gemini3 对应的角色
  const tempRoleIds = { ...originalRoleIds.value }
  // 获取页面选择的 gemini3 角色
  const geminiRole = roleList.value.find(sys => sys.systemSign === 'gemini3')
  if (geminiRole && geminiRole.__selected_value !== undefined && geminiRole.__selected_value !== null && geminiRole.__selected_value !== '') {
    // 先删除原来 gemini3 对应的角色ID
    Object.keys(tempRoleIds).forEach(roleId => {
      if (tempRoleIds[roleId] === 'gemini3') {
        delete tempRoleIds[roleId]
      }
    })
    // 添加新选择的角色
    tempRoleIds[geminiRole.__selected_value] = 'gemini3'
  }

  // 根据 systemSigns 顺序构建 roleIds 数组
  const finalRoleIds = []
  for (const systemSign of finalSystemSigns) {
    // 找到对应系统的角色ID
    const roleId = Object.keys(tempRoleIds).find(id => tempRoleIds[id] === systemSign)
    if (roleId) {
      finalRoleIds.push(Number(roleId))
    }
  }

  const submitData = {
    ...formValues,
    roleIds: finalRoleIds,
    systemSigns: finalSystemSigns,
    disableClosingDate: formatDate(formValues.disableClosingDate),
  }

  if (op.value == 'add') {
    let r = await addUser(submitData)
    if (r?.code == 200) {
      eui.showToast('新增成功', 'success');
      visible.value = false
      updateUserList()
    } else {
      eui.showToast('新增失败，请重试', 'error');
    }
  } else if (op.value == 'edit') {
    let r = await updateUser(submitData)
    if (r?.code == 200) {
      eui.showToast('更新成功', 'success');
      visible.value = false
      updateUserList()
    } else {
      eui.showToast('更新失败，请重试', 'error');
    }
  }
};

function onPhoneInput(event) {
  let value = event.target.value;
  // 只保留数字
  value = value.replace(/[^0-9]/g, '');
  // 限制最多11位
  value = value.slice(0, 11);
  formValues.phonenumber = value;
}

let groupTree = ref([]);
const filterText = ref('');
const treeRef = ref();
const deptMenuVisible = ref(false);
const deptFilterText = ref('');
const deptSelectTreeRef = ref();

const selectedDeptLabel = computed(() => {
  const target = String(formValues.deptId || '');
  if (!target) return '';
  const stack = [...groupTree.value];
  while (stack.length > 0) {
    const node = stack.pop();
    if (!node) continue;
    if (String(node.deptId) === target) return node.label || node.deptName || '';
    if (Array.isArray(node.children) && node.children.length > 0) {
      stack.push(...node.children);
    }
  }
  return '';
});

function filterNode(value, data) {
  if (!value) return true;
  return data.label.includes(value);
}

function onTreeChange(data) {
  userDept.value = data.deptId;
  updateUserList();
}

function onDeptSelect(data) {
  if (!data) return;
  formValues.deptId = data.deptId;
  deptMenuVisible.value = false;
}

watch(deptMenuVisible, (opened) => {
  if (!opened) {
    deptFilterText.value = '';
    return;
  }

  if (deptSelectTreeRef.value) {
    deptSelectTreeRef.value.filter(deptFilterText.value);
  }
});

(async () => {
  try {
    let res = await listDept({})
    if (res && res.data) {
      let data = res.data.filter(item => item.status == '0')
      // 与参考页一致，使用 list2tree 构建组织树
      groupTree.value = list2tree(data)
      if (groupTree.value.length > 0) {
        userDept.value = groupTree.value[0].deptId
      }
    } else {
      console.error('Invalid response from listDept')
    }
  } catch (error) {
    console.error('Error loading dept data:', error)
  }
})()

// 监听搜索文本变化
watch(filterText, (val) => {
  treeRef.value.filter(val);
});

watch(deptFilterText, (val) => {
  if (deptSelectTreeRef.value) {
    deptSelectTreeRef.value.filter(val);
  }
});

let roleList = ref([])
// 后端 listChannelRole 返回：eMind-Gemini 商业版 对应 systemSign = 'gemini3'
const GEMINI_BUSINESS_SYSTEM_SIGN = 'gemini3'


function resetSelectdValue() {
  for (const sys of roleList.value) {
    if (sys.roles.length > 0) {
      sys.__selected_value = sys.roles[0].roleId
    }
  }
}

const roleListLoading = ref(false)
async function updateRuleList() {
  roleListLoading.value = true
  try {
    let r = await listChannelRole()
    const data = r.data || []
    let l = data.filter(item => item.loginWay == '0')
    roleList.value = l.filter(sys => sys.systemSign === GEMINI_BUSINESS_SYSTEM_SIGN)
    resetSelectdValue()
    roleListLoading.value = false
  } catch (e) {
    console.warn(e)
  } finally {
    roleListLoading.value = false
  }

}

updateRuleList()


const pwdRef = ref(null)
const passwordVisible = ref(false)
let passwordForm = reactive({
  userId: '',
  userName: '',
  password: '',
  repassword: '',
})

function formatDate(date) {
  if (!date) return ''
  if (typeof date === 'string') {
    // 如果是字符串，尝试解析
    const d = new Date(date)
    if (isNaN(d.getTime())) return ''
    date = d
  }
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function resetPassword(record) {
  passwordVisible.value = true
  showResetPassword.value = false
  showResetRepassword.value = false
  passwordForm.userId = record.userId
  passwordForm.userName = record.userName
  passwordForm.password = ''
  passwordForm.repassword = ''
}

async function onPasswordConfirm(element) {
  // 阻止默认的表单验证提示
  element.noValidate = true;

  // 手动验证必填字段
  if (!String(passwordForm.password || '').trim()) {
    eui.showToast('请输入新密码', 'error');
    return;
  }
  if (passwordForm.password.length < 5) {
    eui.showToast('请输入至少5位密码', 'error');
    return;
  }
  if (!String(passwordForm.repassword || '').trim()) {
    eui.showToast('请输入重复新密码', 'error');
    return;
  }
  if (passwordForm.repassword.length < 5) {
    eui.showToast('请输入至少5位确认密码', 'error');
    return;
  }
  if (passwordForm.password != passwordForm.repassword) {
    eui.showToast('两次输入的密码不一致', 'error');
    return;
  }

  let r = await resetUserPwd(passwordForm.userId, passwordForm.password)
  if (r.code == 200) {
    eui.showToast('重置成功', 'success');
    passwordVisible.value = false
  } else {
    eui.showToast('重置失败，请重试', 'error');
  }
}

</script>

<style scoped lang="scss">
.card-bg {
  background: #fff;
  backdrop-filter: blur(8px);
}

.card-bd {
  border-radius: 0 0 30px 30px !important;
}

.card-table {
  padding: 24px 16px 0;
  border-radius: 30px !important;
}

.user-management {
  width: 100%;
}

.page-operates {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  .page-header__select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;

    .page-header__select-item {
      display: flex;
      align-items: center;

      .page-header__select-label {
        margin-right: 8px;
        white-space: nowrap;
      }
    }
  }

}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;

  .search-label {
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }

  .search-input {
    width: 220px;
  }
}

.search-input {
  position: relative;
  top: 0;
}

.gm-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(thead tr) {
    background: #f8fafc !important;
  }

  :deep(th) {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.8) !important;
    border: none !important;
    background: #f8fafc !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(td) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(.v-table__wrapper) {
    border-radius: 0;
  }
}

.page-header__btns {
  display: flex;
  gap: 12px;
  align-items: center;
  height: 40px;
}

.query-btn {
  width: 98px;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  border-radius: 12px !important;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 400;
  background: #3a68ff !important;
  color: #fff !important;
  text-transform: none !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #3a68ff !important;
    opacity: 0.9;
  }

  &:active {
    background: #3a68ff !important;
    opacity: 0.8;
  }
}

.tabChangebg {
  display: flex;
  padding-top: 20px;
}

.tab-change {
  width: 100%;
  height: 100%;
}

.form-item-user {
  display: flex;
  flex-flow: column;
  align-items: unset;
}

.user-tab-line {
  display: flex;
  flex-flow: row;
  align-items: center;
  line-height: 40px;
  margin-bottom: 8px;
}

.user-tab-label {
  width: 210px;
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.user-tab-label>span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 8px;
}

.user-tab-label>input {
  flex-grow: 0;
}

.rule__wrap {
  position: relative;
  border: 1px solid var(--border-color);
  padding: 10px;
  flex-grow: 1;
}

.form-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 0 20px 20px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.form-section-title {
  grid-column: span 2;
  margin: 10px 0;
  padding-left: 10px;
  border-left: 4px solid #2655f1;
  font-size: 16px;
  font-weight: 600;
  color: #1f2d3d;
}

.page-body {
  :deep(.v-input__control) {
    display: block;
  }
}

/* 左侧边栏样式 */
.left-sidebar {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: 20px;
}

.search-wrapper {
  position: relative;
  margin-bottom: 12px !important;
  padding: 5px 12px 0px;
}

.device-tree {
  flex: 1;
  overflow-y: auto;
  min-height: 300px;
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: thin;
  scrollbar-color: #D4D9E5 #F7F8FA;
  display: flex;
  flex-direction: column;
}

.tree-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  min-height: 300px;
}

.device-tree::-webkit-scrollbar {
  width: 6px;
}

.device-tree::-webkit-scrollbar-track {
  background: #F7F8FA;
  border-radius: 3px;
}

.device-tree::-webkit-scrollbar-thumb {
  background: #D4D9E5;
  border-radius: 3px;
}

.device-tree::-webkit-scrollbar-thumb:hover {
  background: #B0B8C1;
}

.device-tree :deep(.el-tree) {
  background: #fff;
  color: #2e2e2e;
}

.device-tree :deep(.el-tree-node__content) {
  border-radius: 6px;
  background: transparent;
  transition: background-color 0.2s;
}

.device-tree :deep(.el-tree-node__content:hover) {
  background-color: #f5f5f5;
}

.device-tree :deep(.el-tree-node.is-current > .el-tree-node__content) {
  background-color: #f5f5f5 !important;
}

.user-dialog-card {
  background: linear-gradient(180deg, #F6FBFF 0%, #FFF 100%);
  border-radius: 20px;
  overflow: hidden;
}

.user-dialog-body {
  background: transparent;
  padding: 16px 24px 20px;
}

.dialog-title {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #2E2E2E;
  padding: 16px 24px 0;
  margin: 0;
}

.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 24px !important;
    font-weight: 500;
  }
}

.gm-input {
  :deep(.v-field) {
    background-color: rgba(239, 244, 251, 0.7) !important;
    border-radius: 15px !important;
    box-shadow: none !important;
    padding-inline: 4px !important;

    .v-field__outline {
      display: none !important;
    }

    .v-field__append-inner {
      padding-right: 12px !important;
    }
  }

  &.v-input--focused :deep(.v-field) {
    border-color: #2655f1 !important;
  }
}

.gm-radio-group {
  :deep(.v-selection-control-group) {
    width: 100%;
  }
}

.gm-radio-card {
  flex: 1;
  height: 42px;
  background-color: rgba(239, 244, 251, 0.7) !important;
  border-radius: 15px !important;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex !important;
  align-items: center;
  justify-content: center;

  :deep(.v-selection-control) {
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .v-selection-control__wrapper {
      display: none;
    }
  }

  &.v-selection-control--active {
    background-color: #2655f1 !important;
    box-shadow: 0 4px 12px rgba(38, 85, 241, 0.2) !important;

    :deep(.v-label) {
      color: #fff !important;
      font-weight: 600 !important;
    }
  }
}

:deep(.v-label) {
  font-size: 14px !important;
  color: #2e2e2e;
  margin: 0 !important;
}

.form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  .form-group {
    margin-bottom: 0;

    label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      color: #2e2e2e;
    }

    &.grid-full {
      grid-column: 1 / -1;
    }
  }
}

.required-star {
  color: #ff4d4f;
  margin-left: 4px;
}

.gm-btn-primary {
  border-radius: 15px !important;
  height: 42px;
  background-color: #2655f1 !important;
  box-shadow: 0 4px 12px rgba(38, 85, 241, 0.2) !important;
  transition: all 0.2s ease;

  &:hover {
    background-color: #1e47d8 !important;
  }
}

.gm-btn-secondary {
  border-radius: 15px !important;
  height: 42px;
  background-color: #f0f0f0 !important;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e0e0e0 !important;
  }
}

.dialog-input {
  :deep(.v-field) {
    background: #F7F8FA;
    border-radius: 8px;
    min-height: 40px;
  }

  :deep(.v-field__outline) {
    border: 1px solid #E0E4E7;
    border-radius: 8px;
  }

  :deep(.v-label) {
    color: #6A727C;
    font-size: 14px;
    position: absolute;
    top: -10px;
    left: 12px;
    background: #F7F8FA;
    padding: 0 4px;
    z-index: 1;
  }

  :deep(.v-field__input) {
    color: #2E2E2E;
    font-size: 14px;
  }

  :deep(.v-field--focused) {
    :deep(.v-label) {
      color: #3a68ff;
    }
  }

  :deep(.v-select__list-item) {
    :deep(.v-list-item__title) {
      color: #2E2E2E;
    }
  }
}

.dialog-footer {
  padding: 16px 24px;
  border-top: 1px solid #F0F0F0;
  background: #fff;
}

.dialog-btn {
  height: 40px;
  min-width: 100px;
  border-radius: 8px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-btn-primary {
  background: #3a68ff !important;
  color: #fff !important;
  border: none !important;

  &:hover {
    background: #3256e0 !important;
    color: #fff !important;
  }
}

.dialog-btn-secondary {
  border: 1px solid #D4D9E5 !important;
  color: #2E2E2E !important;
  background: #fff !important;

  &:hover {
    background: #F7F8FA !important;
    color: #2E2E2E !important;
  }
}

/* 表单布局样式 */
.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.form-item {
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.form-item label {
  min-width: 100px;
  white-space: nowrap;
}

.form-item .user-name-display,
.form-item .dialog-input {
  flex: 1;
}

.form-item.full-width {
  min-width: 100%;
}

.form-label {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #2E2E2E;
  white-space: nowrap;
}

.required-mark {
  color: #ff4d4f;
  margin-left: 4px;
}

/* 调整输入框样式，移除之前的标签定位 */
.dialog-input {
  :deep(.v-label) {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    background: transparent !important;
    padding: 0 !important;
  }
}

/* 用户名显示样式 */
.user-name-display {
  display: block;
  padding: 8px 12px;
  background: #F7F8FA;
  border: 1px solid #E0E4E7;
  border-radius: 8px;
  font-size: 14px;
  color: #2E2E2E;
  min-height: 40px;
  line-height: 24px;
}

.dept-select-panel {
  min-width: 460px;
}

.dept-search-input {
  width: 100%;
}

.dept-select-tree-wrap {
  max-height: 280px;
  overflow: auto;
  border: 1px solid #E0E4E7;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
}

.dept-select-tree-wrap :deep(.el-tree-node__content) {
  height: 32px;
}

.status-chip {
  min-width: 60px;
  height: 28px !important;
  line-height: 28px !important;
  justify-content: center;
  border: 1px solid currentColor !important;
}

/* 角色选择单选框样式 */
.role-select-radio {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-radio-label {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background: white;
}

.role-radio-label:hover {
  border-color: #2655f1;
}

input[type="radio"]:checked+.role-radio-label {
  border-color: #2655f1;
  background: white;
}

.role-radio-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2655f1;
  transition: all 0.3s ease;
}

input[type="radio"]:checked+.role-radio-label .role-radio-inner {
  transform: translate(-50%, -50%) scale(1);
}

/* 禁用状态的选择框样式 */
.gm-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

:deep(.v-date-picker-header) {
  display: none;
}
</style>
